module.exports = __webpack_public_path__ + "img/8.1e0c5bc3.jpg";